import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  OnDestroy,
  AfterViewInit,
  Input,
} from "@angular/core";
import { PipelineDetailsDto } from "@cradua/data";
import { fromEvent, Subscription } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  map,
  pluck,
  tap,
} from "rxjs/operators";
import * as XLSX from "xlsx";
type AOA = any[][];

import { GatewayService } from  'libs/gateway/src/lib/services/gateway.service';


@Component({
  selector: 'cradua-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, AfterViewInit, OnDestroy {
 
  @Input() pipelineDetail: PipelineDetailsDto[];
  @Input() task: string;
  @Output() getAllEmit = new EventEmitter<any>();
  @Output() searchEmit = new EventEmitter<any>();
  @Output() emitEvent = new EventEmitter<any>();
  @Output() emitTask = new EventEmitter<any>();

  @ViewChild('myCheckbox', { static: true }) mybox: ElementRef;
  @ViewChild("search", { static: true })
  searchForm: ElementRef;
  searchSubscription$: Subscription;
  isFilter = false;
  data = [];
  dataForUpload = [];
  dataForUploadMain: any;
  showUploadPanel = false;

  constructor(public gatewayService: GatewayService) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.onFilter();
    this.searchSubscription$ = fromEvent(this.searchForm.nativeElement, "keyup")
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        pluck("target", "value"),
        tap(_ => this.task === 'list' ? null : this.emitTask.emit('list')),
        // filter((searchTerm: string) => searchTerm.length > 2),
        map((value) => value),
      )
      .subscribe((data) => {
        console.log('on search ', data)
        this.searchEmit.emit(data)
      });
  }

  toggleUploadPanel(){

    this.showUploadPanel = !this.showUploadPanel;
  }

  // filterWithSubSubGroupId() {
  //   this.searchEmit.emit(this.selectedSubSubGroupId);
  // }

  onFilter() {
    let az = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];

    this.searchSubscription$ =  fromEvent(this.mybox.nativeElement, 'click')
    .pipe(
      debounceTime(500),
      distinctUntilChanged(),
      pluck("target", "value"),
      tap(_ => this.task === 'list' ? null : this.emitTask.emit('list')),
      // filter((searchTerm: string) => searchTerm.length > 2),
      map((value) => value),
    )
    .subscribe((data) => {
      // if(data) {
      //   az.forEach(element => {
      //     // element = element
          
      //   });
      // }
      this.getAllEmit.emit('e')
    });
  }

  createEvent() {
    this.emitTask.emit('create')
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.searchSubscription$) {
      this.searchSubscription$.unsubscribe();
    }
  }


  onFileChange(ev) {
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary', cellDates: true, });
      /* grab first sheet */
      const wsname: string = workBook.SheetNames[0];
      const ws: XLSX.WorkSheet = workBook.Sheets[wsname];

       let sheetName = "";
      /* save data */
      this.data = <AOA>XLSX.utils.sheet_to_json(ws, { header: 1 });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        sheetName = name;
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});

     // this.documents = jsonData.Sheet1;
     
 

     this.dataForUpload = jsonData[sheetName]?.map(item => ({
       ...item,
       'Designed Pressure (bar)': String(item['Designed Pressure (bar)']),
       'Diameter (inch)': String(item['Diameter (inch)']),
       'Installation Year': String(item['Installation Year']),
       'Length (km)': String(item['Length (km)']),
       'License Expiration Date': String(item['License Expiration Date']),
       'License Start Date': String(item['License Start Date']),
       'OPLL No': String(item['OPLL No']),
       'PTS No': String(item['PTS No']),
       'S/No': String(item['S/No']),
       'Wall Thickness (mm)': String(item['Wall Thickness (mm)']),
       'Year of Operating License': String(item['Year of Operating License']),
     }));
     console.log("Data from Excel", this.dataForUpload);
      const dataString = JSON.stringify(jsonData);

      this.dataForUploadMain = JSON.stringify(this.dataForUpload);
      // document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");
      // console.log(jsonData.Sheet1);
      // this.setDownload(dataString);
      //this.isLoading = false;
    };
    reader.readAsBinaryString(file);

  }

  submit(){

    this.gatewayService.isLoading$.next(true);

    this.gatewayService.pipelineDataMigration(this.dataForUploadMain).subscribe((data) => {

      this.gatewayService.isLoading$.next(false);
    }, (error) => {
      this.gatewayService.isLoading$.next(false);
    })

  }
}
